import { paginationField } from './consts';

export default function(editor, opts = {}) {
  const bm = editor.BlockManager;
  const pfx = opts.pfx;

  const style = opts.defaultStyle
    ? `<style>
    .${pfx}-cont,
    .block {
      display: inline-block;
    }
  </style>`
    : '';

  if (opts.blocks.indexOf(paginationField) >= 0) {
    bm.add(paginationField, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"/></svg>
      <div class="gjs-block-label">${opts.label}</div>`,
      category: opts.category,
      content: `
        <div class="${pfx}" data-gjs-type="${pfx}"  data-gjs="${pfx}" style="display: flex;
        flex-direction: row;justify-content: space-between;">
          <div class="${pfx}-info flex-shrink-0" data-gjs-type="text" draggable="true" data-highlightable="1">Page 1 of n</div>
          <nav class="${pfx}-nav" aria-label="Page navigation" data-gjs-type="${pfx}-nav"  data-gjs="${pfx}-nav" data-gjs-custom-name="Pagination Number Nav" data-gjs-selectable="false" data-gjs-highlightable="false">
            <ul class="${pfx}-nav-list pagination" data-gjs-type="${pfx}-nav-list"  data-gjs="${pfx}-nav-list" data-gjs-custom-name="Pagination Number Nav List" data-gjs-selectable="false" data-gjs-highlightable="false">
              <li class="page-item page-item-prev"><a class="page-link link-first" href="javascript:void(0)">Previous</a></li>
              <li class="page-item"><a class="page-link link-1" href="javascript:void(0)">1</a></li>
              <li class="page-item"><a class="page-link link-2" href="javascript:void(0)">2</a></li>
              <li class="page-item page-item-next"><a class="page-link link-next" href="javascript:void(0)">Next</a></li>
            </ul>
          </nav>
        </div> 
        ${style}
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.label
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
